import Header from './components/Header.js';
import './App.css';
import Footer from "./components/Footer";
import Homepage from "./pages/Homepage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AboutMe from "./pages/AboutMe";
import Contacts from "./pages/Contacts";
import KickOff from "./pages/KickOff";
import Services from "./pages/Services";
import RestartMethod from "./pages/RestartMethod";
import ScrollToTop from "./helpers/ScrollToTop";
import CookieBanner from "./helpers/CookieBanner";
function App() {
    return (

            <Router>
                <ScrollToTop />
            <Header />
                <CookieBanner />
                <main>
                    <Routes>
                        <Route path="/" element={<Homepage />} />
                        <Route path="/about-me" element={<AboutMe />} />
                        <Route path="/contacts" element={<Contacts />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/kick-off-performance" element={<KickOff />} />
                        <Route path="/restart-method" element={<RestartMethod />} />
                    </Routes>
                </main>
                <Footer/>
            </Router>



    );
}

export default App;
